import { Home as HomeIcon, X as CloseIcon } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { HeroBanner } from "./HeroBanner";

export const AuthShell = ({ variant, children }) => {
  const navigate = useNavigate();

  // Tag <body> so global CSS can tighten padding + reposition the Emergent preview
  // badge on auth pages (which have no fixed mobile bottom nav).
  useEffect(() => {
    document.body.classList.add("auth-page");
    return () => document.body.classList.remove("auth-page");
  }, []);

  return (
    <div
      className="min-h-screen w-full text-white relative overflow-x-hidden"
      style={{
        background:
          "radial-gradient(90% 60% at 50% 0%, rgba(25,165,92,0.08) 0%, transparent 70%), #0a1119",
      }}
    >
      {/* Ambient decorative glows (desktop only — keeps mobile light & fast) */}
      <div
        aria-hidden
        className="hidden lg:block pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full blur-3xl opacity-40"
        style={{ background: "radial-gradient(circle, #19a55c 0%, transparent 70%)" }}
      />
      <div
        aria-hidden
        className="hidden lg:block pointer-events-none absolute top-40 -right-24 h-72 w-72 rounded-full blur-3xl opacity-30"
        style={{ background: "radial-gradient(circle, #ff2740 0%, transparent 70%)" }}
      />

      {/* Top bar — clean baji logo only, no sponsor pin */}
      <header className="relative z-10 flex items-center justify-between px-4 py-3 border-b border-white/5 backdrop-blur-sm">
        <a
          href="/"
          className="flex items-center"
          data-testid="auth-logo-link"
          aria-label="home"
        >
          <Logo className="text-3xl font-extrabold tracking-tight" />
        </a>
        <div className="flex items-center gap-1.5">
          <button
            type="button"
            onClick={() => navigate("/")}
            aria-label="home"
            data-testid="header-home-btn"
            className="h-9 w-9 rounded-md flex items-center justify-center text-white/70 hover:text-white hover:bg-white/5 transition-colors"
          >
            <HomeIcon size={20} />
          </button>
          <button
            type="button"
            onClick={() => navigate("/")}
            aria-label="close"
            title="Close"
            data-testid="header-close-btn"
            className="h-9 w-9 rounded-md flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-colors"
          >
            <CloseIcon size={20} />
          </button>
        </div>
      </header>

      {/* Hero */}
      <HeroBanner variant={variant} />

      {/* Form area — wrapped in a glass card on sm+ for a polished feel. */}
      <main className="relative z-10 px-4 sm:px-6 pb-20 sm:pb-20 pt-6 sm:pt-10">
        <div
          data-testid="auth-card"
          className="max-w-md mx-auto w-full rounded-2xl sm:p-6 sm:bg-white/[0.02] sm:border sm:border-white/10 sm:shadow-[0_20px_60px_-20px_rgba(25,165,92,0.25)] sm:backdrop-blur"
        >
          {children}
        </div>
        <p className="text-center text-white/35 text-xs mt-6">
          © {new Date().getFullYear()} Maxlive88 · Play Smart, Win Big
        </p>
      </main>
    </div>
  );
};
